import { signInWithCredential, OAuthProvider, browserLocalPersistence, setPersistence } from "firebase/auth";
import { auth } from "../../../Components/MiddlePopup/SignInModal/firebaseConfig.ts";

export const getAppleProfileInfo = async (identityToken: string) => {
    try {
        const provider = new OAuthProvider('apple.com');
        const credential = provider.credential({
            idToken: identityToken,
        });

        // Set persistence before signing in
        await setPersistence(auth, browserLocalPersistence);
        const result = await signInWithCredential(auth, credential);

        return result.user;
    } catch (error) {
        console.error('Error getting Apple profile info:', error);
        throw error;
    }
};